<template>
  <div class="bindbox">
    <div class="rimg"></div>
    <div class="bindmobile">
      <div class="bindmobiletitle">
        <!-- <img src="/static/icon/touxiang.jpeg" alt="" /><span>Hi,老毛</span> -->

        <el-avatar
          shape="square"
          :size="64"
          :src="
            userinfo && userinfo.avatar
              ? userinfo.avatar
              : '/static/icon/head.png'
          "
          style="margin-right: 20px"
        ></el-avatar>
        <div>
          <span>Hi,{{ userinfo && userinfo.nickName }}</span>
        </div>
      </div>
      <div class="bindmobiletishi">
        <span>綁定手機，便於下次快速登録</span>
      </div>
      <el-form
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
        style="margin-top: 40px"
      >
        <el-form-item label="手機號" prop="name">
          <!-- <el-input
                placeholder="請輸入手機號"
                v-model="changemobile.mobile"
              >
                <el-select
                  v-model="ac"
                  class="ac-ipt"
                  slot="prepend"
                  style="width: 100px"
                >
                  <el-option
                    v-for="item in codeList"
                    :key="item"
                    :value="item"
                    :label="'+' + item"
                  />
                </el-select>
              </el-input> -->
          <el-input
            v-model="changemobile.mobile"
            placeholder="請輸入手機號"
            class="input-with-select phonebox"
          >
            <el-select v-model="ac" slot="prepend" class="ac-ipt" size="small">
              <el-option
                v-for="item in codeList"
                :key="item"
                :value="item"
                :label="'+' + item"
              />
            </el-select>
          </el-input>
        </el-form-item>
        <el-form-item label="驗證碼" prop="name" style="position: relative">
          <el-input
            placeholder="請輸入驗證碼"
            style="width: 100%"
            v-model="changemobile.smsCode"
          ></el-input
          ><el-button
            @click.prevent="getSMSNew()"
            type="primary"
            plain
            style="
              width: 112px;
              position: absolute;
              right: 12px;
              top: 3.85px;
              color: #aa1d1f;
            "
            >{{ changemobile.text }}</el-button
          >
        </el-form-item>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer"
        style="text-align: center; margin-bottom: 50px"
      >
        <el-button type="primary" class="section1" @click="bindMobil()"
          >登録并綁定手機</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import eventBus from '@/utils/eventBus.js'
import {
  getArticleList,
  smsCode,
  getPhoneCode,
  changeMobile,
  getInfo
} from '@/api/api'
export default {
  name: 'BindMobile',
  data: () => {
    return {

      baseUrl: window.__baseUrl__,
      // dialogFormVisible: true,
      // loginDialogVisible: false,//登录弹窗
      changemobile: {
        mobile: "",
        smsCode: "",
        text: "獲取驗證碼",
        timer: null,
        uuid: ""
      },
      userinfo: {},
      ac: "86",
      codeList: ["86", "852"],

    }
  },
  mounted () {
    this.userinfo = localStorage.userInfo ? JSON.parse(localStorage.userInfo) : {}
    this.changemobile.mobile = ''
    this.changemobile.smsCode = ''
    this.changemobile.timer = null
    //获取区号
    getPhoneCode().then(res => {
      if (res.code == 200) {
        this.codeList = res.data
        this.ac = this.codeList[0]
      }

    })
  },
  created () {
    this.changemobile.mobile = ''
    this.changemobile.smsCode = ''
    this.changemobile.timer = null
  },
  methods: {
    getSMSNew () {

      // if (!/^[1][35789][0-9]{9}$/.test(this.changemobile.mobile)) {
      if (!/^[0-9]*$/.test(this.changemobile.mobile)) {
        this.$message.error("請輸入正確手機號")
        return
      }

      if (this.changemobile.text === "獲取驗證碼") {
        smsCode({
          mobile: this.ac + this.changemobile.mobile,
          scene: "BIND"
        }).then(res => {
          if (res.code == 500) {
            this.$message.error(res.msg)
            return
          }
          let num = 60
          this.changemobile.timer = setInterval(() => {
            num--

            if (num === 0) {
              clearInterval(this.changemobile.timer)
              this.changemobile.timer = null
              this.changemobile.text = `獲取驗證碼`
            }
            else {
              this.changemobile.text = `重新獲取(${num}s)`
              // console.log(num,'num');
            }
          }, 1000)

          this.changemobile.uuid = res.uuid
          // this.form.smsCode = res.smsCode
        })
      } else {
      }
    },
    //绑定手机号
    bindMobil () {
      let { mobile, smsCode, uuid } = this.changemobile
      if (!/^[0-9]*$/.test(mobile)) {
        this.$message.error("請輸入正確手機號")
        return
      }
      changeMobile({ mobile: this.ac + mobile, smsCode, uuid, scene: "BIND" }).then((res) => {
        if (res.code == 200) {
          // this.dialogFormVisible = false
          eventBus.$emit("openBindMobile", false)
          if (res.token) {
            localStorage.setItem("token", "Bearer " + res.token)
          }
          //平台用户只有在支付的时候绑定手机号
          // getInfo().then(d => {
          //   if (d.code == 200 && d.user.isCompany == 1) {
          //     this.$bus.$emit("getImgCode") //打开支付码
          //   }
          // })
          // if (this.ispaypath) {
          //   this.$bus.$emit("getImgCode") //打开支付码
          // }
          // this.getUserInfo()
          eventBus.$emit("getUserInfo")
          this.$nextTick(() => {
            eventBus.$emit("getlocalinfo")
          })

          this.$message.success("綁定成功")

        } else {
          this.$message.error(res.msg)
          //测试完删除
          // this.dialogFormVisible = false
          // getInfo().then(d => {
          //   if (d.code == 200 && d.user.isCompany == 1) {
          //     this.$bus.$emit("getImgCode") //打开支付码
          //   }
          // })
        }
      })

    },



  },


}
</script>

<style lang="less" scoped>
/deep/.phonebox .el-input__inner:nth-child(2) {
  padding-left: 80px;
}
/deep/.el-input-group__append,
/deep/.el-input-group__prepend {
  border: none;
  background-color: white;
  position: absolute;
  left: 5px;
  top: 10px;
}
/deep/.el-select .el-input {
  width: 80px;
  line-height: 45px;
}
/deep/.imgcodebox {
  justify-content: space-between;
}
/deep/.impowerBox .qrcode {
  width: 186px;
}
/deep/ .el-input__inner {
  border-radius: 26px;
  height: 45px;
  border: 1px solid #dddddd;
}
/deep/.el-input__suffix {
  line-height: 45px;
}

/* 谷歌 */
/deep/ .el-input__inner::-webkit-input-placeholder {
  color: #454545;
  font-weight: 600;
}

/* 火狐 */
/deep/ .el-input__inner:-moz-placeholder {
  color: #454545;
  font-weight: 600;
}

/*ie*/
/deep/ .el-input__inner:-ms-input-placeholder {
  color: #454545;
  font-weight: 600;
}

/* //获取焦点时的颜色 */
/deep/ .el-input__inner:focus::-webkit-input-placeholder {
  color: #454545;
  font-weight: 600;
}

/deep/ .el-input__inner:focus::-moz-input-placeholder {
  color: #454545;
  font-weight: 600;
}

/deep/ .el-input__inner:focus::-ms-input-placeholder {
  color: #454545;
  font-weight: 600;
}
/deep/.el-button--primary.is-plain {
  background: none;
  border: none;
}
/deep/.el-button--primary.is-plain:hover {
  color: #409eff;
}
.section1 {
  height: 45px;
  border-radius: 28.5px 28.5px 28.5px 28.5px;
  background-color: rgba(170, 29, 31, 1);
  width: 200px;
  // padding: 0.43rem 0 0 3.6rem;
  border: none;
}
body {
  margin: 0;
}
html {
  font-size: 37.5px;
}
.bindbox {
  border-radius: 20px;
  display: flex;
  justify-content: space-between;
}
.bindmobile {
  width: 450px;
  margin: 0 auto;
  box-sizing: border-box;

  .bindmobiletitle {
    width: 100%;
    height: 64px;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 64px;
      height: 64px;
      border-radius: 3px;
      margin-right: 20px;
    }
    span {
      font-size: 18px;
    }
  }
  .bindmobiletishi {
    margin-top: 60px;
    width: 100%;
    text-align: center;
    span {
      font-size: 14px;
    }
  }
}

/deep/.el-dialog {
  border-radius: 12px;
}
/deep/.el-dialog__body {
  padding: 0;
}
/deep/.el-dialog__header {
  padding: 0;
}
.bindmobile {
  padding: 30px 40px 0 0;
  .bindmobiletitle {
    // display: flex;
  }
}
.bindmobiletitle {
  text-align: center;
}
.bindmobiletishi {
  text-align: center;
}
* {
  scrollbar-width: thin;
  scrollbar-color: #eee #ccc;
}
.rimg {
  width: 200px;
  background: url("/static/login/loginboxbg.png") no-repeat;
  background-size: auto 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/bindMobile.vue